import React from 'react';
import FlagIcon from 'Common/Components/FlagIcon/index';
import { updateVuln } from 'store/Manage/actions';
import { useSelector, useDispatch } from 'react-redux';
import { selectVulnDetail } from 'store/Manage/selectors';
import get from 'lodash/get';
import { Wrapper, Label } from './styled';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectIsReadOnly } from 'store/Faraday/selectors';

const DisplayConfirmed = () => {
  const dispatch = useDispatch();
  const vuln = useSelector(selectVulnDetail);
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const confirmed = get(vuln, 'confirmed', false);
  const readOnly = useSelector(selectIsReadOnly);
  const canUpdate = !readOnly && allowedByRole;
  const handleClick = () => {
    if (canUpdate) dispatch(updateVuln(vuln, 'confirmed', !confirmed, true));
  };
  return (
    <Wrapper>
      <FlagIcon
        theme={ confirmed ? 'confirmed' : 'notConfirmed' }
        alt={ confirmed ? 'Confirmed' : 'Un-confirmed' }
        onClick={ handleClick }
        aria-label={ confirmed ? 'Confirmed' : 'Not confirmed' }
      />
      <Label>{confirmed ? 'Confirmed' : 'Not Confirmed'}</Label>
    </Wrapper>
  );
};

export default DisplayConfirmed;
